export const FETCH_APPOINTMENTS_SUCCESS = 'FETCH_APPOINTMENTS_SUCCESS';
export const CHANGE_APPOINTMENT_STATUS = 'CHANGE_APPOINTMENT_STATUS';
